module.exports = __webpack_public_path__ + "img/image2.6fcdfcee.jpg";